import BookingModule from "@/components/sections/BookingModule";

export default function Booking() {
    return (
        <div>
            <BookingModule />
        </div>
    );
}